import styled from 'styled-components';

export const ApplicationsListContainerStyled = styled(`div`)`
	display: none;
	@media (max-width: 575px) {
		display: block;
		width: 100%;
		margin-bottom: 16px;
	}
`;
